	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.fundamental.Material.MaterialFactory;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-fundamental/ref/Material/MaterialFactory.js
// module id = 14
// module chunks = 0